BaseHandler = App.loadClass 'core::reports/BaseHandler'
DetailOutput = App.loadClass 'core::reports/DetailOutput'
BaseOutput = App.loadClass 'core::reports/BaseOutput'

class exports.Reports_Fertilizer_SubHandler extends BaseHandler
    init: () ->
        @hasPrint       = true
        @excelUrl       = 'backend/grower/reports/fertilizer/excel'
        @filterUrl      = 'backend/grower/reports/fertilizer/filters'
        @layoutSelector = '#reports_fertilizer_tab'

        @parent.dialog.find('.excel-btn').removeClass('hidden')
        @initFilters()

    initFilters: () ->
        @resetFilters()

        @parent.filters.importGroup
            name: 'Fertilizer Filters'
            filters: [
                {
                    name: 'timings'
                    display_name: 'Timing'
                },
                {
                    name: 'sources'
                    display_name: 'Source'
                },
                {
                    name: 'application_date'
                    display_name: 'Application Date'
                    control_type: 'daterangepicker'
                    listenForYear: (years) ->
                        years = years.map (val) ->
                            val.key
                        drp = $(@ele).data('daterangepicker')
                        min = _.min years
                        max = _.max years

                        if not min and not max
                            $(@ele).prop('disabled', true)
                        else
                            $(@ele).prop('disabled', false)

                            # Set the earliest and latest dates a user can select based on selected years
                            drp?.minDate = moment((min - 1).toString().concat('-1-1'), 'YYYY-MM-DD')
                            drp?.maxDate = moment((max + 1).toString().concat('-12-31'), 'YYYY-MM-DD')
                },
                {
                    name: 'status'
                    display_name: 'Status'
                    control_type: 'option'
                    deletable: false
                    values: [
                        { key: 'planned', value: 'Plan' },
                        { key: 'actual', value: 'Record' }
                    ]
                    selected_values: [
                        { key: 'actual', value: 'Record' },
                    ]
                },
                {
                    name: 'output_type'
                    display_name: 'Output Type'
                    control_type: 'option'
                    deletable: false
                    values: [
                        { key: 'detail', value: 'Detail' },
                        { key: 'summary', value: 'Summary' }
                    ],
                    selected_values: [
                        { key: 'detail', value: 'Detail' }
                    ],
                }
            ]

        @setDefaultsAndRun()


    destroy: () ->
        @parent.filters.removeGroup "Fertilizer Filters"
        @parent.dialog.find('.excel-btn').addClass('hidden')
        super()

    beforeApply: () ->
        filters = @parent.filters.jsonize()
        if filters.filters.output_type[0].key is 'detail'
            @printUrl      = 'backend/grower/reports/fertilizer/print/detail'
            @layoutUrl     = 'backend/grower/reports/fertilizer/table/detail'
            @currentOutput = new DetailOutput this, @parent, 'auto', { sAjaxSource: 'backend/grower/reports/fertilizer/output/detail' }
        else
            @printUrl      = 'backend/grower/reports/fertilizer/print/summary'
            @layoutUrl     = 'backend/grower/reports/fertilizer/output/summary'
            @currentOutput = new BaseOutput this, @parent, 'auto'
